import Dashboard from './Dashboard';
import Channel from './Channel';
import ChannelForm from './ChannelForm';
import { formatDataToModel } from '../../utils';

export default class DashboardForm {
  constructor(channel = null, complete_exercises = null, draft_classes = null, incomplete_exercises = null, playbooks = null, published_classes = null, templates = null, unlabeled_exercise_videos = null, stripe_connected = null, trainer_relationship) {
    this.channel = channel;
    this.complete_exercises = complete_exercises;
    this.draft_classes = draft_classes;
    this.incomplete_exercises = incomplete_exercises;
    this.playbooks = playbooks;
    this.published_classes = published_classes;
    this.templates = templates;
    this.unlabeled_exercise_videos = unlabeled_exercise_videos;
    this.stripe_connected = stripe_connected;
    this.trainer_relationship = trainer_relationship;
  }

  formatForForm(obj) {
    const channelForm = new ChannelForm();
    const exer = new Dashboard();
    if(obj) {
      for (const key in exer) {
        if (obj.hasOwnProperty(key)) {
          exer[key] = obj[key];
        }
      }
    }

    const modelObj = formatDataToModel(exer.channel, Channel);

    if(modelObj){
      channelForm.formatForForm(modelObj);
    }

    this.channel = channelForm;
    this.complete_exercises = exer.complete_exercises;
    this.draft_classes = exer.draft_classes;
    this.incomplete_exercises = exer.incomplete_exercises;
    this.playbooks = exer.playbooks;
    this.published_classes = exer.published_classes;
    this.templates = exer.templates;
    this.unlabeled_exercise_videos = exer.unlabeled_exercise_videos;
    this.stripe_connected = exer.stripe_connected;
    this.trainer_relationship = exer.trainer_relationship;

    this.checkValidity();
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};
    const channelText = 'Channel is complete';
    const publishedClassesText = '1 Published Class';
    const playbookText = '1 Playbook';
    const paymentText = 'Stripe Account is Connected';

    this.channel.checkValidity();
    
    if(this.channel.primaryStatus === 'Valid') {
      statusList.channel = {value: true, text: channelText};
    } else {
      primaryStatus = 'Invalid';
      statusList.channel = {value: false, text: channelText};
    }

    if (this.trainer_relationship === "trainer") {
      if(this.published_classes >= 1) {
        statusList.published_classes = {value: true, text: publishedClassesText};
      } else {
        primaryStatus = 'Invalid';
        statusList.published_classes = {value: false, text: publishedClassesText};
      }

      if(this.playbooks > 0) {
        statusList.playbooks = {value: true, text: playbookText};
      } else {
        primaryStatus = 'Invalid';
        statusList.playbooks = {value: false, text: playbookText};
      }
    }

    if(this.stripe_connected) {
      statusList.stripe = {value: true, text: paymentText};
    } else {
      primaryStatus = 'Invalid';
      statusList.stripe = {value: false, text: paymentText};
    }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
